import { Environment } from '@campaign-portal/components-library';

export const environment: Environment = {
	production: true,
	version: '1.8.1-0.sha.bde4909',
	releaseDate: '2026-07-30T06:00:00Z',

	protocol: '',
	host: '',
	port: '',
	api: 'api',
	localStorageKey: 'cp',
	configURL: `./assets/config.json?v=${Date.now()}`,

	wsHost: '',
	wsPort: '',
	wsApi: 'api/ws',

	title: 'Alaris Labs',
	subTitle: 'Campaign Portal',

	theme: 'default',
	themeType: 'dark',

	termsUrl: '',
	privacyUrl: '',
	supportEmail: '',

	showLink: true,
	allowRegistration: true,

	systemTZOffset: 0,
	localTime: true,

	languagesID: ['en', 'es', 'tr'],

	is2FA: false,
	sessionTimeout: 60,
};
